<h1>Search</h1>
<div class="icon-note">
    <a>Note: Icons are not included in search. To find icons use the </a>
    <a [routerLink]="['/build', 'foundations', 'iconography', 'system-icons']"
        >icon search</a
    >
    <a>.</a>
</div>

<div class="search-content">
    <form class="search" #filterFor="ngForm" (ngSubmit)="onSubmit()">
        <ui-search [hasContent]="!!value" (clearSearch)="resetForm()">
            <input
                autocomplete="off"
                id="search"
                name="text"
                placeholder="Search site for text"
                type="text"
                [(ngModel)]="value"
            />
        </ui-search>
    </form>
    <div class="searchResults">
        @if (isSearching) {
        <div class="searchResults--loading">
            <uilab-mat-progress-bar
                mode="indeterminate"
                [color]="loadingColor"
            ></uilab-mat-progress-bar>
        </div>
        } @if (error) {
        <app-error [error]="error"></app-error>
        } @if (!initial && !isSearching && (searchResults.length == 0) && (value
        != '') && (!error)) {
        <div class="searchResults--none">
            <p
                >Couldn't find any matches for
                <strong>{{this.searched}}</strong>.</p
            >
        </div>
        } @if (!initial && (searchResults.length > 0)) {
        <div class="searchResults--list">
            @if (isSearching) {
            <h3 class="searchResults--title"> Here's what we found so far: </h3>
            }@else{
            <h3 class="searchResults--title"> Here's what we found: </h3>
            } @for (page of searchResults; track page) {
            <dl class="searchResults--item">
                <dt class="searchResults--item--title route">
                    <a [routerLink]="getSearchResultRouterLink(page.path)">{{page.title}}</a>
                </dt>
                <dd class="searchResults--item--desc">
                    @if (page.collapsable) {
                    <span>
                        @if (page.collapsed) {
                        <span>
                            @for (preview of page.collapsedPreviews; track
                            preview) {
                            <span>
                                <app-inner-content
                                    [content]="preview"
                                ></app-inner-content>
                            </span>
                            }
                            <p>
                                <button
                                    class="more"
                                    (click)="page.collapsed=false"
                                    >Show More...</button
                                >
                            </p>
                        </span>
                        } @if (!page.collapsed) {
                        <span>
                            @for (preview of page.previews; track $index) {
                            <span>
                                <app-inner-content
                                    [content]="preview"
                                ></app-inner-content>
                            </span>
                            }
                            <p>
                                <button
                                    class="more"
                                    (click)="page.collapsed=true"
                                    >Show Less...</button
                                >
                            </p>
                        </span>
                        }
                    </span>
                    } @if (!page.collapsable) {
                    <span>
                        @for (preview of page.collapsedPreviews; track $index) {
                        <span>
                            <app-inner-content
                                [content]="preview"
                            ></app-inner-content>
                        </span>
                        }
                    </span>
                    }
                </dd>
            </dl>
            }
            <div></div>
        </div>
        }
    </div>
</div>
